import { store } from "../..";
import { IOrgsRedux, CurrentRouteActionTypes, ROUTE_PATH, SET_CURRENT_ORG, SET_ORG_LIST, SET_THEME, SET_ORG_PERMISSIONS } from "./types";

export function sendCurrentRoutePath(org: IOrgsRedux): CurrentRouteActionTypes {
    return {
        type: ROUTE_PATH,
        data: org
      }
}

export function setCurrentOrganization(data: IOrgsRedux) {
  return {
    type: SET_CURRENT_ORG,
    data: {...data, "userId": store.getState().user.data.user.id}
  }
}

export function setOrgList(data: any) {
  return {
    type: SET_ORG_LIST,
    data: data
  }
}

export function setCurrentTheme(data: any) {
  return {
    type: SET_THEME,
    data: data
  }
}

export function setOrgPermissions(data: IOrgsRedux) {
  return {
    type: SET_ORG_PERMISSIONS,
    data: data
  }
}